import React, { useState } from "react";
import {
 Box,
 Button,
 Input,
 FormControl,
 FormLabel,
 Heading,
 VStack,
 useToast,
} from "@chakra-ui/react";
import Select from "react-select";
import axios from "axios";

const states = [
 "Karnataka",
 "Jammu and Kashmir",
 "Uttarakhand",
 "Arunachal Pradesh",
 "Meghalaya",
 "Himachal Pradesh",
 "Gujarat",
 "Assam",
 "Dadra and Nagar Haveli",
 "Kerala",
 "West Bengal",
 "Maharashtra",
 "Madhya Pradesh",
 "Delhi",
 "Rajasthan",
 "Bihar",
 "Sikkim",
 "Tamil Nadu",
 "Orissa",
 "Goa",
 "Andhra Pradesh",
 "Telangana",
 "Chhattisgarh",
 "Mizoram",
 "Punjab",
 "Jharkhand",
 "Uttar Pradesh",
];

const budgetOptions = [
 "Below 50 lakhs",
 "50-70 lakhs",
 "70-90 lakhs",
 "90-110 lakhs",
 "No issues with budget",
];

const formatOptions = (arr) => arr.map((value) => ({ label: value, value }));

const MbbsInquiryForm = ({ onSuccess }) => {
 const [formData, setFormData] = useState({
  name: "",
  contactDetail: "",
  city: "",
  state: null,
  budget: null,
 });

 const toast = useToast();

 const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {
   ...formData,
   state: formData.state?.value,
   budget: formData.budget?.value,
  };

  try {
   const res = await axios.post(
    "https://admission-backend-theta.vercel.app/api/mbbs-inquiry",
    payload
   );

   // Reset the form data
   setFormData({
    name: "",
    contactDetail: "",
    city: "",
    state: null,
    budget: null,
   });

   // Call the onSuccess function passed via props to close modal and show success toast
   onSuccess();
  } catch (error) {
   toast({
    title: "Error",
    description: "Failed to submit inquiry.",
    status: "error",
    duration: 6000,
    isClosable: true,
   });
  }
 };

 return (
  <Box maxW="600px" mx="auto" mt={10} p={6} borderWidth="1px" borderRadius="md">
   <Heading mb={6} textAlign="center" size="lg">
    MBBS Inquiry Form
   </Heading>
   <form onSubmit={handleSubmit}>
    <VStack spacing={4}>
     <FormControl isRequired>
      <FormLabel>Name</FormLabel>
      <Input
       placeholder="Enter your name"
       value={formData.name}
       onChange={(e) => setFormData({ ...formData, name: e.target.value })}
      />
     </FormControl>

     <FormControl isRequired>
      <FormLabel>Contact Detail</FormLabel>
      <Input
       placeholder="Phone or Email"
       value={formData.contactDetail}
       onChange={(e) =>
        setFormData({ ...formData, contactDetail: e.target.value })
       }
      />
     </FormControl>

     <FormControl isRequired>
      <FormLabel>City</FormLabel>
      <Input
       placeholder="Enter your city"
       value={formData.city}
       onChange={(e) => setFormData({ ...formData, city: e.target.value })}
      />
     </FormControl>

     <FormControl isRequired>
      <FormLabel>State</FormLabel>
      <Select
       options={formatOptions(states)}
       placeholder="Select State"
       isSearchable
       value={formData.state}
       onChange={(selectedOption) =>
        setFormData({ ...formData, state: selectedOption })
       }
      />
     </FormControl>

     <FormControl isRequired>
      <FormLabel>Expected Budget</FormLabel>
      <Select
       options={formatOptions(budgetOptions)}
       placeholder="Select Budget"
       isSearchable
       value={formData.budget}
       onChange={(selectedOption) =>
        setFormData({ ...formData, budget: selectedOption })
       }
      />
     </FormControl>

     <Button type="submit" colorScheme="blue" width="full">
      Submit Inquiry
     </Button>
    </VStack>
   </form>
  </Box>
 );
};

export default MbbsInquiryForm;

// // MbbsInquiryForm.jsx
// import React, { useState } from "react";
// import {
//  Box,
//  Button,
//  Input,
//  FormControl,
//  FormLabel,
//  Heading,
//  VStack,
//  useToast,
// } from "@chakra-ui/react";
// import Select from "react-select";
// import axios from "axios";

// const states = [
//  "Karnataka",
//  "Jammu and Kashmir",
//  "Uttarakhand",
//  "Arunachal Pradesh",
//  "Meghalaya",
//  "Himachal Pradesh",
//  "Gujarat",
//  "Assam",
//  "Dadra and Nagar Haveli",
//  "Kerala",
//  "West Bengal",
//  "Maharashtra",
//  "Madhya Pradesh",
//  "Delhi",
//  "Rajasthan",
//  "Bihar",
//  "Sikkim",
//  "Tamil Nadu",
//  "Orissa",
//  "Goa",
//  "Andhra Pradesh",
//  "Telangana",
//  "Chhattisgarh",
//  "Mizoram",
//  "Punjab",
//  "Jharkhand",
//  "Uttar Pradesh",
// ];

// const budgetOptions = [
//  "Below 50 lakhs",
//  "50-70 lakhs",
//  "70-90 lakhs",
//  "90-110 lakhs",
//  "No issues with budget",
// ];

// const formatOptions = (arr) => arr.map((value) => ({ label: value, value }));

// const MbbsInquiryForm = () => {
//  const [formData, setFormData] = useState({
//   name: "",
//   contactDetail: "",
//   city: "",
//   state: null,
//   budget: null,
//  });

//  const toast = useToast();

//  const handleSubmit = async (e) => {
//   e.preventDefault();

//   const payload = {
//    ...formData,
//    state: formData.state?.value,
//    budget: formData.budget?.value,
//   };

//   try {
//    const res = await axios.post(
//     "https://admission-backend-theta.vercel.app/api/mbbs-inquiry",
//     payload
//    );
//    toast({
//     title: "Inquiry submitted.",
//     description: "We will contact you shortly.",
//     status: "success",
//     duration: 6000,
//     isClosable: true,
//    });
//    setFormData({
//     name: "",
//     contactDetail: "",
//     city: "",
//     state: null,
//     budget: null,
//    });
//   } catch (error) {
//    toast({
//     title: "Error",
//     description: "Failed to submit inquiry.",
//     status: "error",
//     duration: 6000,
//     isClosable: true,
//    });
//   }
//  };

//  return (
//   <Box maxW="600px" mx="auto" mt={10} p={6} borderWidth="1px" borderRadius="md">
//    <Heading mb={6} textAlign="center" size="lg">
//     MBBS Inquiry Form
//    </Heading>
//    <form onSubmit={handleSubmit}>
//     <VStack spacing={4}>
//      <FormControl isRequired>
//       <FormLabel>Name</FormLabel>
//       <Input
//        placeholder="Enter your name"
//        value={formData.name}
//        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//       />
//      </FormControl>

//      <FormControl isRequired>
//       <FormLabel>Contact Detail</FormLabel>
//       <Input
//        placeholder="Phone or Email"
//        value={formData.contactDetail}
//        onChange={(e) =>
//         setFormData({ ...formData, contactDetail: e.target.value })
//        }
//       />
//      </FormControl>

//      <FormControl isRequired>
//       <FormLabel>City</FormLabel>
//       <Input
//        placeholder="Enter your city"
//        value={formData.city}
//        onChange={(e) => setFormData({ ...formData, city: e.target.value })}
//       />
//      </FormControl>

//      <FormControl isRequired>
//       <FormLabel>State</FormLabel>
//       <Select
//        options={formatOptions(states)}
//        placeholder="Select State"
//        isSearchable
//        value={formData.state}
//        onChange={(selectedOption) =>
//         setFormData({ ...formData, state: selectedOption })
//        }
//       />
//      </FormControl>

//      <FormControl isRequired>
//       <FormLabel>Expected Budget</FormLabel>
//       <Select
//        options={formatOptions(budgetOptions)}
//        placeholder="Select Budget"
//        isSearchable
//        value={formData.budget}
//        onChange={(selectedOption) =>
//         setFormData({ ...formData, budget: selectedOption })
//        }
//       />
//      </FormControl>

//      <Button type="submit" colorScheme="blue" width="full">
//       Submit Inquiry
//      </Button>
//     </VStack>
//    </form>
//   </Box>
//  );
// };

// export default MbbsInquiryForm;
